<template>
  <div v-if="showSpectators && spectators.length" style="margin: auto">
    <span class="has-text-primary">Spectators:</span>
    <div class="is-flex is-justify-content-center is-align-items-center">
      <span
        v-for="player in spectators.slice(0, maxToShow)"
        :key="player.user_id"
        @mouseover="hoveredId = player.user_id"
        @mouseleave="hoveredId = null"
      >
        <ProfileCard
          :player="player"
          :rating="player.stats ? player.stats.rating : null"
          :challenge="false"
          type="topMini"
        />
      </span>
      <a v-if="spectators.length > maxToShow" @click="maxToShow += 9">
        &amp; {{ spectators.length - maxToShow }} more</a
      >
      <a
        v-if="spectators.length <= maxToShow && maxToShow > 9"
        @click="maxToShow = 9"
      >
        show less</a
      >
    </div>
  </div>
</template>

<script>
import RoomRenderlessVue from "./RoomRenderless.vue";
import ProfileCard from "@/components/players/ProfileCard.vue";
import { mapGetters } from "vuex";

export default {
  components: { ProfileCard },

  name: "RoomSpectators",

  extends: RoomRenderlessVue,

  props: ["match", "showSpectators"],

  data() {
    return {
      hoveredId: null,
      maxToShow: 9,
    };
  },

  computed: {
    ...mapGetters(["getUserId"]),

    spectators() {
      // return Array(12).fill(this.players[0]);
      if (!this.players || !this.players.length) return [];
      if (this.match) {
        return this.players.filter(
          (player) =>
            player &&
            player.user_id &&
            this.match.player1 &&
            this.match.player2 &&
            this.match.player1.user_id !== player.user_id &&
            this.match.player2.user_id !== player.user_id
        );
      }
      return this.players;
    },
  },
};
</script>

<style scoped></style>
